<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Retorno de mercaderia fuera de ruta
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Recorridos</span>
      <span> /</span>
      <span>Retorno de mercaderia fuera de ruta</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="showModalAdd()" size="sm" mdbWavesEffect>
        Agregar
      </button>
    </div>
    <form autocomplete="off" [formGroup]="formHeader">
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsChofer" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              formControlName="chofer" placeholder="Seleccionar Chofer"></mdb-select>
            <label>Chofer</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsCamion" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              formControlName="camion" placeholder="Seleccionar Camión"></mdb-select>
            <label>Camión</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" formControlName="fecha">
            </mdb-date-picker>
            <div *ngIf="
              formHeader.get('fecha').invalid &&
              (formHeader.get('fecha').dirty ||
              formHeader.get('fecha').touched)
              ">
              <!-- <mdb-error *ngIf="formHeader.get('fecha').hasError('required')">
                Ingrese fecha
              </mdb-error> -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaMovimientos">

      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Correlativo</th>
            <th scope="col">Chofer</th>
            <th scope="col">Camión</th>
            <th scope="col">Fecha</th>
            <th scope="col">Cliente</th>
            <th scope="col">RUT</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{mov.codigo}}</td>
            <td>{{mov.nombreChofer}}</td>
            <td>{{mov.camion_patente}}</td>
            <td>{{mov.fecha_registro | fecha}}</td>
            <td>{{mov.nombreCliente}}</td>
            <td>{{mov.rutClienteFormato | rut}}</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="showModalView(mov)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar retorno -->
<app-retorno-mercaderia-modal-add-edit mode="ADD" (onSuccess)="buscar()"></app-retorno-mercaderia-modal-add-edit>

<!-- MODAL Ver retorno -->
<app-retorno-mercaderia-modal-add-edit mode="VIEW"></app-retorno-mercaderia-modal-add-edit>